module.exports = __webpack_public_path__ + "img/hovered-layer7.569294ff.png";